import React from 'react';

import './modal.css';

type ModalProps = {
  isActive: boolean;
  message: string;
  subtitle?: string;
  confirmMessage?: string;
  // When set, a cancel button is shown alongside confirm.
  cancelMessage?: string;
  // Skips the fade-in delay, for modals opened directly by a tap.
  isInstant?: boolean;
  confirmDisabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
};

export const Modal = ({
  isActive,
  message,
  subtitle,
  confirmMessage,
  cancelMessage,
  isInstant = false,
  confirmDisabled = false,
  className,
  children,
  onConfirm,
  onCancel
}: ModalProps) => {
  return (
    <div
      onClick={onCancel}
      className={'modalOverlay' + (isActive ? ' active' : '') + (isInstant ? ' instant' : '')}
    >
      <div
        className={'modalItself' + (className ? ` ${className}` : '')}
        onClick={e => e.stopPropagation()}
      >
        <p className='modalTitle'>{message}</p>
        {subtitle && <p className='modalSubtitle'>{subtitle}</p>}
        {children}
        <div className='modalButtons'>
          {cancelMessage && (
            <button className='reverse' onClick={onCancel}>
              {cancelMessage}
            </button>
          )}
          <button disabled={confirmDisabled} onClick={onConfirm}>
            {confirmMessage || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
};
